import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ModalService } from './modal.service';
import { ModalOptions } from './models/modal-options.model';
import { SpanLinkModalBase } from './span-link-modal-base';

@Component({
    selector: 'span-link',
    template: require('./span-link.component.html')
})
export class SpanLinkComponent extends SpanLinkModalBase {
    @Input() public modalContent: string;
    @Input() public modalTitle: string;
    @Input() public backdropCssClass: string;
    @Input() public showCancel: boolean;
    @Input() public acceptText: string;
    @Input() public cancelText: string;

    @Output() public linkClicked: EventEmitter<SpanLinkComponent> = new EventEmitter<SpanLinkComponent>(true);
    @Output() public okClicked: EventEmitter<Event> = new EventEmitter<Event>(true);
    @Output() public cancelClicked: EventEmitter<Event> = new EventEmitter<Event>(true);

    constructor(protected modalService: ModalService) {
        super(modalService);
    };

    public setCustomOptions(options: ModalOptions): void {
        options.onOkClickedCallBack = ((event: Event) => {
            this.okClicked.emit(event);
        });
        options.onCancelClickedCallBack = ((event: Event) => {
            this.cancelClicked.emit(event);
        });
    }

    protected onClicked(event: Event): void {
        this.show();
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/coverage-modal/span-link.component.ts